import { ProConfigProvider } from '@ant-design/pro-components';
import { useTheme } from '@zhiyue/core';
import type { ThemeConfig } from 'antd';
import { App, ConfigProvider, theme } from 'antd';
import React from 'react';
import './index.less';

// 与 SessionProvider 的平台状态同步；此处只修正组件主题边界，不维护另一份主题。
export default function PlatformTheme({
  children,
  staticMessages = false,
}: React.PropsWithChildren<{ staticMessages?: boolean }>) {
  const { navTheme } = useTheme();
  const dark = navTheme === 'realDark';
  const config = React.useMemo<ThemeConfig>(
    () => ({
      inherit: false,
      algorithm: dark ? theme.darkAlgorithm : theme.defaultAlgorithm,
      cssVar: { key: dark ? 'platform-dark' : 'platform-light' },
      token: { colorBgLayout: dark ? '#141414' : '#ffffff' },
      components: {
        Table: {
          headerBg: dark ? '#1f1f1f' : '#f6f7f9',
          rowHoverBg: dark ? '#262626' : '#f6f7f9',
          rowSelectedBg: dark ? '#111d2c' : '#e6f4ff',
        },
        Button: {
          primaryShadow: 'none',
          defaultShadow: 'none',
          dangerShadow: 'none',
        },
      },
    }),
    [dark],
  );
  React.useEffect(() => {
    if (!staticMessages) return;
    document.documentElement.dataset.theme = dark ? 'dark' : 'light';
    ConfigProvider.config({
      holderRender: (node) => (
        <ConfigProvider theme={config}>
          <App className="platform-ui">{node}</App>
        </ConfigProvider>
      ),
    });
  }, [config, dark, staticMessages]);
  return (
    <ConfigProvider theme={config}>
      <ProConfigProvider dark={dark}>
        <App className="platform-ui">{children}</App>
      </ProConfigProvider>
    </ConfigProvider>
  );
}
